export default __webpack_public_path__ + "static/media/probability.2dcfda1c.png";